import React from 'react';
import { useCookies } from 'react-cookie';
import { useProfileState } from '../../context/ProfileContext';

// Scopes are "<realm>:read" / "<realm>:write" strings on the role, e.g.
// role.scopes = ["organisation:read", "organisation:write", "billing:read"].
// read and write are granted independently — a check requires that exact scope
// to be present (write does NOT imply read).
//
// A membership can hold multiple roles (currentOrganisation.roles is an array
// of role ids); the effective scope set is the union of all assigned roles.

export const useRoleCheck = () => {

    const { organisation, organisations, roles, loading } = useProfileState();
    const [cookies, setCookie] = useCookies();

    const _roleCheck = (scope) => {

        if (loading) {
            return false;
        }

        let roleIds = [];
        const currentOrganisation = organisations.find(org => org.id === organisation.id);

        if (currentOrganisation && Array.isArray(currentOrganisation.roles)) {
            roleIds = currentOrganisation.roles;
        } else if (cookies.Partner) {
            if (cookies.Partner === "2") {
                roleIds = [organisation.adminRole];
            } else if (cookies.Partner === "1") {
                roleIds = [organisation.readRole];
            }
        } else {
            return false;
        }

        // The exact scope must be present; read and write are granted independently
        for (const id of roleIds) {
            const role = roles.find(role => role.id === id);

            if (!role || !Array.isArray(role.scopes)) {
                continue;
            }

            if (role.scopes.includes(scope)) {
                return true;
            }
        }

        return false;
    };

    const RoleCheckWrapper = ({ children, scope }) => {

        if (_roleCheck(scope)) {
            return (
                <React.Fragment>
                    { children}
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment />
            );
        }

    };

    const roleCheck = (scope) => {
        //Reversed boolean for button disabling
        if (_roleCheck(scope)) {
            return false;
        } else {
            return true;
        }

    };

    return {
        roleCheck: roleCheck,
        RoleCheckWrapper: RoleCheckWrapper
    }

}